import React from 'react';
import axios from 'axios';
import { Route, Switch, Redirect, NavLink } from 'react-router-dom';
import About from './About';
import AffiliateDisclosure from './AffiliateDisclosure';
import Input from './Input';
import Output from './Output';
import Products from './Products';
import ProductDetail from './ProductDetail';
import { PageView, initGA, Event } from './Tracking';
import logo from './assets/logo.png';

class App extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			ingredients: [],
			products: [],
			value: '',
			showOutput: false,
			currentYear: new Date().getFullYear()
		}

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		initGA(process.env.REACT_APP_GOOGLE_ANALYTICS);
		PageView();

		axios
			.get('/api/products')
			.then( products => {
				this.setState({products: products.data})
			})
			.catch(err => {
				this.setState({products: []})
			});
	}

	handleChange(event) {
		this.setState({value: event.target.value});
	}

	handleSubmit(event) {
		event.preventDefault();

		if (!this.state.value.trim()) {
			this.setState({value: ''});
			return false;
		}

		Event("User", `User searched: ${this.state.value}`, "Search Button");

		axios
			.get('/api/search', {
				params: {
					ingredients: this.state.value
				}
			})
			.then( ingredients => {
				this.setState({ingredients: ingredients.data, showOutput: true})
			})
			.catch(err => {
				this.setState({ingredients: []})
			});
	}

	handleCopyrightClick(event) {
		event.preventDefault();
	}

	render() {
		return (
			<div className='wrapper'>
				<div className="header">
					<NavLink to="/" className="logo">
						<img src={logo} alt="logo" id="logo"/>
					</NavLink>
					<div className="header-right">
						<NavLink exact to="/" activeClassName="active">Ingredient Analyzer</NavLink>
						<NavLink exact to="/products" activeClassName="active">Products</NavLink>
						<NavLink to="/about" activeClassName="active">About</NavLink>
					</div>
				</div>
				<hr className="title-line"></hr>
				<div className="main-section">
					<Switch>
						<Route exact path="/">
							<div className="top-container">
								<div>
									<h1>Ingredient Analyzer</h1>
									<Input
										value= { this.state.value }
										onChange={ this.handleChange }
										onSubmit= { this.handleSubmit }
									/>
								</div>
								<div className="headline">
									Make sure the products you apply keep you clear.
								</div>
							</div>
							{ this.state.showOutput ?
								<Output
									ingredients={ this.state.ingredients }
								/>
								: null
							}
							<h1 className="recommended-products">Recommended Products</h1>
							<Products products= { this.state.products }/>
						</Route>
						<Route path={'/products/:productId(\\d+)'} component={ProductDetail}/>
						<Route path={'/about'} component={About}/>
						<Route path={'/products'} component={Products}/>
						<Route path={'/affiliate-disclosure'} component={AffiliateDisclosure}/>
						<Redirect to="/" />
					</Switch>
				</div>
				<hr className="footer-line"></hr>
				<footer>
					<NavLink to="/affiliate-disclosure" activeClassName="active">Affiliate Disclosure</NavLink>
					<NavLink className="copyright-link" onClick={this.handleCopyrightClick} to="/copyright">&copy; Rosaceafedup {this.state.currentYear}</NavLink>
				</footer>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx